angular
	.module 'App.Directive'
	.factory 'RequiredLabelToggle', () ->
		toggleLabel = ($elem, labelState) ->
			label = $elem.closest('.input-container').find('label')

			if label.length
				label.toggleClass('required', labelState)

		return {toggleLabel: toggleLabel}
	.directive 'required', (RequiredLabelToggle) ->
		restrict: 'A'
		link: ($scope, $elem) ->
			RequiredLabelToggle.toggleLabel $elem, true
	.directive 'ngRequired', (RequiredLabelToggle) ->
		restrict: 'A'
		link: ($scope, $elem, $attr) ->
			$attr.$observe 'required', (newState) ->
				RequiredLabelToggle.toggleLabel $elem, newState
